/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Add_UpdateInputs */

const en_case_detail_add_update = /** @type {(inputs: Case_Detail_Add_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add update`)
};

const pt_br2_case_detail_add_update = /** @type {(inputs: Case_Detail_Add_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar update`)
};

/**
* | output |
* | --- |
* | "Add update" |
*
* @param {Case_Detail_Add_UpdateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_add_update = /** @type {((inputs?: Case_Detail_Add_UpdateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Add_UpdateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_add_update(inputs)
	return pt_br2_case_detail_add_update(inputs)
});